import "./IconArrowPoint.scss";
import { ReactComponent as ArrowPointIcon } from "./svg/icon_arrow_point.svg";

export const IconArrowPoint = () => {
  return (
    <span className="IconArrowPoint">
      <ArrowPointIcon />
    </span>
  );
};
